import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useReactToPrint } from 'react-to-print';

import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, List,InputNumber,Steps,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined,
    ShoppingCartOutlined,
    DeleteOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice} from '../../../Redux/actions/productActions'
import {addCartItem,getCart,deleteCartItem,editCartItem,clearCart} from '../../../Redux/actions/cartActions'
import {createPackage,getPackageData} from '../../../Redux/actions/packageActions'

import {errorParser,camelToSentence} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'
import InputSelect from '../../Generic/InputSelect'
import ImageChecker from '../../Generic/ImageChecker'
import QRCode from "react-qr-code";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const { Step } = Steps;

const Index = ({currentItem}) => { 
    
    const dispatch = useDispatch()    
    const { user,cart,locations } = useSelector(state => ({
      user: state.auth.user,
      cart: state.cart.data,
      locations: state.locations.locations 
    }), shallowEqual)


    const [current, setCurrent] = useState(0); 
    const [packageSteps, setPackageSteps] = useState([]); 

  


    useEffect(() => {
      console.log(currentItem)
      if(currentItem){
      var newSteps = []
      if(currentItem.created_at){
        var item = {
          title: 'Created',
          description: `${moment(currentItem.created_at).format('LLL')} - ${currentItem.created_name}`
        }
        newSteps.push(item)
      }
      if(currentItem.approved_at){
        var item = {
          title: 'Approved',
          description: `${moment(currentItem.approved_at).format('LLL')} - ${currentItem.approved_by_name}`
        }
        newSteps.push(item)
      }
      if(currentItem.packed_at){
        var item = {
          title: 'Packed',
          description: `${moment(currentItem.packed_at).format('LLL')} - ${currentItem.packed_name}`
        }
        newSteps.push(item)
      }
      if(currentItem.shipped_at){
        var item = {
          title: 'Shipped',
          description: `${moment(currentItem.shipped_at).format('LLL')} - ${currentItem.shipped_name}`
        }
        newSteps.push(item)
      }
      if(currentItem.received_at){
        var item = {
          title: 'Received',
          description: `${moment(currentItem.received_at).format('LLL')} - ${currentItem.received_name}`
        }
        newSteps.push(item)
      }
      if(currentItem.cancelled_at){
        var item = {
          title: 'Cancelled',
          description: `${moment(currentItem.cancelled_at).format('LLL')} - ${currentItem.cancelled_name}`
        }
        newSteps.push(item)
      }

      setPackageSteps(newSteps)
      setCurrent(newSteps.length-1)
      }
    },[currentItem]);



    return(       
      <div className='packagesteps_contianer'>
        <Divider orientation='left'> Progress </Divider>
        <Steps progressDot  direction={'vertical'} className='packagesteps' current={current} size={'small'}>
          {packageSteps.map(item=>{
            return(
              <Step title={item.title} description={item.description} />
            )
          })}        
          
        </Steps>

      </div>

    )
}
  
export default Index
  